<app-performance>
    <app-my-reviews></app-my-reviews>
</app-performance>